module.exports = __webpack_public_path__ + "img/kitty2.2cb03427.jpg";